/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import React from 'react';
import { SvgChevronRight } from '../utils';
import { IconButton } from '../Buttons';
export const SubRowExpander = (props) => {
    const { cell, isDisabled, cellProps, expanderCell } = props;
    return (React.createElement(React.Fragment, null, expanderCell ? (expanderCell(cellProps)) : (React.createElement(IconButton, { style: { marginRight: 8 }, className: 'iui-table-row-expander', styleType: 'borderless', size: 'small', onClick: (e) => {
            e.stopPropagation();
            cell.row.toggleRowExpanded();
        }, disabled: isDisabled }, React.createElement(SvgChevronRight, { style: {
            transform: cell.row.isExpanded ? 'rotate(90deg)' : undefined,
        } })))));
};
export default SubRowExpander;
